import type { BuildType } from './ApiService';

/** What a save sends. No cover: see the note on the catalog in `challenges.ts`. */
export interface ChallengeSave {
    slug: string;
    title: string;
    description?: string;
    url?: string;
    source: string;
}

export const challengeApiEndpoints = (build: BuildType) => ({
    favoriteChallenge: build.mutation<void, ChallengeSave>({
        query: challenge => ({
            url: 'user-challenges/favorite',
            method: 'POST',
            body: challenge,
        }),
        invalidatesTags: ['Favorites'],
    }),
});
